import { render, staticRenderFns } from "./PlanetIcons.vue?vue&type=template&id=48a7a3ea&"
import script from "./PlanetIcons.vue?vue&type=script&lang=js&"
export * from "./PlanetIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports